import Loadable from "../../components/Loadable";
import { lazy } from "react";
import { HIERARCHY, PERMISSION, ROLE_PERMISSION, USERS, WORKLOCATION, HOLIDAYS } from "../../utils/constant";
const AddRole = Loadable(lazy(() => import("./AddRole")));
const Permission = Loadable(lazy(() => import("./AddPermission")));
const Users = Loadable(lazy(() => import("./Users")));
const Profile = Loadable(lazy(() => import("./Profile")));
const WorkLocation = Loadable(lazy(() => import("./AddWorkLocation")));
const UserAdd = Loadable(lazy(() => import("./UserAdd")));
const ViewProfile = Loadable(lazy(() => import("./userProfile/ViewProfile")));
const HierarchyView = Loadable(lazy(() => import("./hierarchy/hierarchyView")));
const DocumentTypes = Loadable(lazy(() => import("./DocumentType/DocumentType")));
const Holidays = Loadable(lazy(() => import("./holidays/Holidays")));
const TwoFactorAuth = Loadable(lazy(() => import("./TwoFactorAuth")));
const CrmWorkspaces = Loadable(lazy(() => import("./CrmWorkspaces")));
const settingsRoute = [

  {
    path: "/settings/role",
    element: <AddRole />,
    permission: ROLE_PERMISSION,
    // auth:ROLE_PERMISSION
  },
  {
    path: "/settings/permission",
    element: <Permission />,
    permission: PERMISSION,
  },
  {
    path: "/settings/users",
    element: <Users />,
    permission: USERS,
  },
  {
    path: '/settings/addUserData',  // Add this
    element: <UserAdd />
  },

  {
    path: "/settings/profile",
    element: <Profile />,
    permission: USERS,
  },
  {
    path: "/settings/workspaces",
    element: <CrmWorkspaces />,
    permission: USERS,
  },
  {
    path: "/settings/workLocation",
    element: <WorkLocation />,
    permission: WORKLOCATION,
  },
  {
    path: "/settings/addNewUser",
    element: <UserAdd />,
    permission: USERS,
  },
  {
    path: "/settings/viewProfile/:id",
    element: <ViewProfile />,
    permission: USERS,
  },
  {
    path: "/settings/hierarchy",
    element: <HierarchyView />,
    permission: HIERARCHY,
  },
  {
    path: "/settings/documentType",
    element: <DocumentTypes />,
    permission: USERS, // Using USERS permission as a placeholder
  }
  ,
  {
    path: "/settings/holidays",
    element: <Holidays />,
    permission: HOLIDAYS,
  },
  {
    path: "/settings/2fa",
    element: <TwoFactorAuth />,
    permission: USERS,
  }
];


export default settingsRoute;
